import React, { PureComponent } from 'react';
import MomentPropTypes from 'react-moment-proptypes';
import PropTypes from 'prop-types';
import CardSectionHeading from '../CardSectionHeading';
import CardRowKeyVal from '../CardRowKeyVal';
import moment from 'moment-timezone';
import get from 'lodash/get';
import map from 'lodash/map';
import currencyFormatter from 'currency-formatter';

const propTypes = {
  beneficiaries: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
  details: PropTypes.shape({
    rides: PropTypes.arrayOf(
      PropTypes.shape({
        product_desc: PropTypes.string,
        miles_distance: PropTypes.number,
        local_started: MomentPropTypes.momentString,
      })
    ),
    pax_name: PropTypes.string,
    accidental_death: PropTypes.number,
    accidental_medical: PropTypes.number,
  }),
};

const defaultProps = {
  details: {},
};

class PolicyDetailsRides extends PureComponent {

  get accidentalDeathPriceStr() {
    return currencyFormatter.format(get(this.props.details, 'accidental_death'), {
      code: get(this.props.billing, 'currency_code'),
    });
  }

  get accidentalMedicalPriceStr() {
    return currencyFormatter.format(get(this.props.details, 'accidental_medical'), {
      code: get(this.props.billing, 'currency_code'),
    });
  }

  get rideDetailsNode() {
    return map(get(this.props.details, 'rides'), (ride, i) => {
      const rideTimeMoment = moment(ride.local_started);
      return (
        <CardRowKeyVal
          key={i}
          title={ride.product_desc}
          detail={
            <div>
              {rideTimeMoment.format('MMM DD, YYYY')}
              <br/>
              {rideTimeMoment.format('H:mm a')} • {Math.round(ride.miles_distance * 10) / 10} mi
            </div>
          }
        />
      );
    });
  }

  render() {
    const {
      details,
      beneficiaries,
    } = this.props;

    return (
      <div>
        <CardRowKeyVal
          title="Passenger"
          detail={get(details, 'pax_name')}
        />
        <CardRowKeyVal
          title="Primary beneficiary"
          detail={get(beneficiaries, '[0].name')}
        />
        <CardSectionHeading>
          Ride Details
        </CardSectionHeading>
        {this.rideDetailsNode}

        <CardSectionHeading>
          Policy Selections
        </CardSectionHeading>
        <CardRowKeyVal
          title="Accidental death and dismemberment"
          detail={this.accidentalDeathPriceStr}
        />
        <CardRowKeyVal
          title="Accidental medical coverage"
          detail={this.accidentalMedicalPriceStr}
        />
      </div>
    );
  }
}

PolicyDetailsRides.propTypes = propTypes;
PolicyDetailsRides.defaultProps = defaultProps;

export default PolicyDetailsRides;
